import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ContactPayload } from "./useCreateContact";

export default function useUpdateContact() {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (contact: ContactPayload & { id: number }) => {
      return api.put(`/contacts/${contact.id}`, contact);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["contacts"] });
      client.invalidateQueries({ queryKey: ["contacts-by-company"] });
      client.invalidateQueries({ queryKey: ["contact-names"] });
      client.invalidateQueries({ queryKey: ["contact-companies"] });
    },
  });
}
